export default __webpack_public_path__ + "static/media/menu.c76f0d00.svg";